document.documentElement.classList.add('js');

const setupContinueShopping = () => {
  document.querySelectorAll('[data-continue-shopping]').forEach((link) => {
    link.addEventListener('click', (event) => {
      try {
        const referrer = document.referrer ? new URL(document.referrer) : null;
        const isSameStore = referrer && referrer.origin === window.location.origin;
        const isDifferentPage = referrer && referrer.pathname !== window.location.pathname;

        if (isSameStore && isDifferentPage) {
          event.preventDefault();
          window.location.assign(referrer.href);
        }
      } catch {
        // Keep the homepage fallback if the previous page cannot be read.
      }
    });
  });
};

setupContinueShopping();

const updateCartCount = async () => {
  try {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return;

    const cart = await response.json();
    document.querySelectorAll('.cart-count').forEach((count) => {
      count.textContent = String(cart.item_count || 0);
    });
  } catch {
    // Keep the current page stable if the cart endpoint is unavailable.
  }
};

const formatCartMoney = (cents) =>
  `$${((Number(cents) || 0) / 100).toFixed(2)}`;

const escapeCartHtml = (value) =>
  String(value || '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
  }[character]));

const renderCartPopup = (cart) => {
  const itemsContainer = document.querySelector('[data-cart-popup-items]');
  const totalContainer = document.querySelector('[data-cart-popup-total]');

  if (!itemsContainer || !totalContainer) return;

  totalContainer.textContent = formatCartMoney(cart.total_price);

  if (!cart.items || cart.items.length === 0) {
    itemsContainer.innerHTML = '<p>Your cart is empty.</p>';
    return;
  }

  itemsContainer.innerHTML = cart.items.map((item) => {
    const title = escapeCartHtml(item.product_title);
    const key = escapeCartHtml(item.key);
    const image = item.image
      ? `<img src="${escapeCartHtml(item.image)}" alt="${title}">`
      : `<div class="cart-popup__item-image"></div>`;

    return `
      <div class="cart-popup__item" data-cart-popup-line data-line-key="${key}">
        ${image}

        <div>
          <p class="cart-popup__item-title">${title}</p>
          <p class="cart-popup__item-meta">${formatCartMoney(item.final_line_price)}</p>

          <div class="cart-popup__line-controls">
            <div class="cart-popup__qty" aria-label="Quantity">
              <button type="button" data-cart-popup-quantity-minus aria-label="Decrease quantity">-</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-popup-quantity-plus aria-label="Increase quantity">+</button>
            </div>

            <button type="button" class="cart-popup__remove" data-cart-popup-remove>
              Remove
            </button>
          </div>
        </div>
      </div>
    `;
  }).join('');
};

const openCartPopup = async () => {
  const popup = document.querySelector('[data-cart-popup]');
  const backdrop = document.querySelector('.cart-popup-backdrop');

  if (!popup || !backdrop) return;

  const response = await fetch('/cart.js', {
    headers: { Accept: 'application/json' },
  });

  if (response.ok) {
    const cart = await response.json();
    renderCartPopup(cart);
  }

  const updateCartPopupLine = async (lineKey, quantity) => {
  const popup = document.querySelector('[data-cart-popup]');
  if (popup) {
    popup.classList.add('is-updating');
  }

  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: lineKey,
        quantity,
      }),
    });

    if (!response.ok) {
      throw new Error('Unable to update cart.');
    }

    const cart = await response.json();

    renderCartPopup(cart);
    await updateCartCount();
  } finally {
    if (popup) {
      popup.classList.remove('is-updating');
    }
  }
};

document.addEventListener('click', async (event) => {
  const line = event.target.closest('[data-cart-popup-line]');
  if (!line) return;

  const lineKey = line.dataset.lineKey;
  if (!lineKey) return;

  const quantityText = line.querySelector('.cart-popup__qty span');
  const currentQuantity = Number.parseInt(quantityText ? quantityText.textContent : '1', 10) || 1;

  if (event.target.closest('[data-cart-popup-quantity-minus]')) {
    await updateCartPopupLine(lineKey, Math.max(0, currentQuantity - 1));
  }

  if (event.target.closest('[data-cart-popup-quantity-plus]')) {
    await updateCartPopupLine(lineKey, currentQuantity + 1);
  }

  if (event.target.closest('[data-cart-popup-remove]')) {
    await updateCartPopupLine(lineKey, 0);
  }
});
  backdrop.hidden = false;

  window.requestAnimationFrame(() => {
    popup.classList.add('is-open');
    backdrop.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-popup-open');
  });
};

const closeCartPopup = () => {
  const popup = document.querySelector('[data-cart-popup]');
  const backdrop = document.querySelector('.cart-popup-backdrop');

  if (!popup || !backdrop) return;

  popup.classList.remove('is-open');
  backdrop.classList.remove('is-open');
  popup.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('cart-popup-open');

  window.setTimeout(() => {
    if (!backdrop.classList.contains('is-open')) {
      backdrop.hidden = true;
    }
  }, 220);
};

document.addEventListener('click', (event) => {
  if (event.target.closest('[data-cart-popup-close]')) {
    closeCartPopup();
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeCartPopup();
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.matches('.product-form, .product-card__form')) return;

  event.preventDefault();

  const button = form.querySelector('[type="submit"]');
  if (button) {
    button.setAttribute('aria-busy', 'true');
  }

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    });

    if (!response.ok) {
      throw new Error('Unable to add item to cart.');
    }

    await updateCartCount();
    await openCartPopup();

    if (button) {
      const originalText = button.dataset.originalText || button.textContent;
      button.dataset.originalText = originalText;
      button.textContent = 'Added';
      window.setTimeout(() => {
        button.textContent = button.dataset.originalText || originalText;
      }, 1400);
    }
  } catch {
    if (button) {
      const originalText = button.dataset.originalText || button.textContent;
      button.dataset.originalText = originalText;
      button.textContent = 'Try again';
      window.setTimeout(() => {
        button.textContent = button.dataset.originalText || originalText;
      }, 1800);
    }
  } finally {
    if (button) {
      button.removeAttribute('aria-busy');
    }
  }
});

document.addEventListener('toggle', (event) => {
  const details = event.target;
  if (!(details instanceof HTMLDetailsElement)) return;
  if (!details.matches('.site-header__details') || !details.open) return;

  document.querySelectorAll('.site-header__details[open]').forEach((openDetails) => {
    if (openDetails !== details) {
      openDetails.open = false;
    }
  });
}, true);

document.addEventListener('toggle', (event) => {
  const details = event.target;
  if (!(details instanceof HTMLDetailsElement)) return;
  if (!details.matches('.filter-dropdown') || !details.open) return;

  document.querySelectorAll('.filter-dropdown[open]').forEach((openDetails) => {
    if (openDetails !== details) {
      openDetails.open = false;
    }
  });
}, true);

document.addEventListener('click', (event) => {
  if (event.target.closest('.site-header__details')) return;

  document.querySelectorAll('.site-header__details[open]').forEach((details) => {
    details.open = false;
  });
});

const mobileMenuDrawer = document.querySelector('[data-mobile-menu-drawer]');
const mobileMenuBackdrop = document.querySelector('.mobile-menu-backdrop');
const mobileMenuOpenButton = document.querySelector('[data-mobile-menu-open]');

const closeMobileMenu = () => {
  if (!mobileMenuDrawer || !mobileMenuBackdrop || !mobileMenuOpenButton) return;

  mobileMenuDrawer.classList.remove('is-open');
  mobileMenuDrawer.setAttribute('aria-hidden', 'true');
  mobileMenuBackdrop.classList.remove('is-open');
  mobileMenuOpenButton.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('mobile-menu-is-open');

  window.setTimeout(() => {
    if (!mobileMenuBackdrop.classList.contains('is-open')) {
      mobileMenuBackdrop.hidden = true;
    }
  }, 220);
};

const openMobileMenu = () => {
  if (!mobileMenuDrawer || !mobileMenuBackdrop || !mobileMenuOpenButton) return;

  mobileMenuBackdrop.hidden = false;
  window.requestAnimationFrame(() => {
    mobileMenuDrawer.classList.add('is-open');
    mobileMenuBackdrop.classList.add('is-open');
    mobileMenuDrawer.setAttribute('aria-hidden', 'false');
    mobileMenuOpenButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mobile-menu-is-open');
  });
};

document.addEventListener('click', (event) => {
  if (event.target.closest('[data-mobile-menu-open]')) {
    openMobileMenu();
    return;
  }

  if (event.target.closest('[data-mobile-menu-close]')) {
    closeMobileMenu();
    return;
  }

  if (event.target.closest('.mobile-menu-drawer a')) {
    closeMobileMenu();
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeMobileMenu();
  }
});

document.addEventListener('toggle', (event) => {
  const details = event.target;
  if (!(details instanceof HTMLDetailsElement)) return;
  if (!details.matches('.mobile-menu-drawer__details') || !details.open) return;

  document.querySelectorAll('.mobile-menu-drawer__details[open]').forEach((openDetails) => {
    if (openDetails !== details) {
      openDetails.open = false;
    }
  });
}, true);

document.addEventListener('click', (event) => {
  const animatedButton = event.target.closest('.button, .shopify-payment-button__button, .variant-option-button, .quantity-stepper button, .shop-follow-link');
  if (animatedButton) {
    animatedButton.classList.remove('is-click-swirling');
    window.requestAnimationFrame(() => {
      animatedButton.classList.add('is-click-swirling');
      window.setTimeout(() => {
        animatedButton.classList.remove('is-click-swirling');
      }, 560);
    });
  }
});

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
  if (!button) return;

  const stepper = button.closest('[data-quantity-stepper]');
  const input = stepper ? stepper.querySelector('input[name="quantity"], input[name="updates[]"]') : null;
  if (!input) return;

  const currentValue = Number.parseInt(input.value, 10) || 1;
  const nextValue = button.matches('[data-quantity-minus]')
    ? Math.max(1, currentValue - 1)
    : currentValue + 1;

  input.value = String(nextValue);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

const getVariantData = (picker) => {
  const variantsScript = picker.querySelector('[data-variant-json]');
  try {
    return JSON.parse(variantsScript ? variantsScript.textContent : '[]');
  } catch {
    return [];
  }
};

const getJsonScriptData = (root, selector) => {
  const script = root.querySelector(selector);
  try {
    return JSON.parse(script ? script.textContent : '[]');
  } catch {
    return [];
  }
};

const getVariantMediaData = (picker) =>
  getJsonScriptData(picker, '[data-variant-media-json]');

const getProductMediaData = (picker) =>
  getJsonScriptData(picker, '[data-product-media-json]');

const getVariantGroups = (picker) =>
  Array.from(picker.querySelectorAll('[data-option-index]')).sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex));

const getSelectedOptions = (picker) =>
  getVariantGroups(picker).map((optionGroup) => {
    const activeButton = optionGroup.querySelector('.variant-option-button.is-active:not([hidden])');
    return activeButton ? activeButton.dataset.optionValue : '';
  });

const setActiveVariantButton = (group, activeButton) => {
  group.querySelectorAll('.variant-option-button').forEach((optionButton) => {
    const isActive = optionButton === activeButton;
    optionButton.classList.toggle('is-active', isActive);
    optionButton.setAttribute('aria-pressed', String(isActive));
  });
};

const syncSelectedColorLabel = (group) => {
  if (!group || group.dataset.colorOption !== 'true') return;

  const selectedLabel = group.querySelector('[data-selected-option-value]');
  const activeButton = group.querySelector('.variant-option-button.is-active:not([hidden])');
  if (!selectedLabel || !activeButton) return;

  selectedLabel.textContent = activeButton.dataset.optionDisplayValue || activeButton.dataset.optionValue || '';
};

const syncSelectedVariantLabels = (picker) => {
  getVariantGroups(picker).forEach((group) => {
    syncSelectedColorLabel(group);
  });
};

const getSelectedColorValue = (picker) => {
  const colorGroup = picker.querySelector('[data-color-option="true"]');
  const activeColor = colorGroup ? colorGroup.querySelector('.variant-option-button.is-active:not([hidden])') : null;
  return activeColor ? (activeColor.dataset.optionDisplayValue || activeColor.dataset.optionValue || '') : '';
};

const normalizeMediaMatchText = (value) =>
  String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');

const findMediaForSelectedVariant = (picker, selectedVariant) => {
  const variantMedia = getVariantMediaData(picker);
  const match = variantMedia.find((item) => String(item.id) === String(selectedVariant.id));
  if (match && match.media) return match.media;

  const selectedColor = normalizeMediaMatchText(getSelectedColorValue(picker));
  if (!selectedColor) return null;

  return getProductMediaData(picker).find((media) => {
    const mediaAlt = normalizeMediaMatchText(media.alt);
    return mediaAlt && mediaAlt.includes(selectedColor);
  }) || null;
};

const syncVariantMedia = (picker, selectedVariant) => {
  const form = picker.closest('form');
  const scope = picker.closest('[data-product-card], .product');
  if (!form || !scope || !selectedVariant) return;

  const media = findMediaForSelectedVariant(picker, selectedVariant);
  if (!media || !media.src) return;

  const image = scope.querySelector('[data-product-media] img, .product-card__media-image, .product__media-image');
  if (!image) return;

  image.src = media.src;
  if (media.srcset) {
    image.srcset = media.srcset;
  }
  if (media.alt) {
    image.alt = media.alt;
  }
};

const variantMatchesOptions = (variant, selectedOptions) => {
  if (!Array.isArray(variant.options)) return false;
  return selectedOptions.every((value, index) => !value || variant.options[index] === value);
};

const optionHasAvailableVariant = (variants, selectedOptions, optionIndex, optionValue) =>
  variants.some((variant) => {
    if (!variant.available || !Array.isArray(variant.options)) return false;
    if (variant.options[optionIndex] !== optionValue) return false;

    return variant.options.every((value, index) => {
      if (index >= optionIndex) return true;
      return !selectedOptions[index] || selectedOptions[index] === value;
    });
  });

const updateVariantOptionVisibility = (picker) => {
  const variants = getVariantData(picker);
  const groups = getVariantGroups(picker);

  groups.forEach((group) => {
    const optionIndex = Number(group.dataset.optionIndex);
    const selectedOptions = getSelectedOptions(picker);

    group.querySelectorAll('.variant-option-button').forEach((button) => {
      const isAvailable = optionHasAvailableVariant(variants, selectedOptions, optionIndex, button.dataset.optionValue);
      button.hidden = !isAvailable;
      button.disabled = !isAvailable;
      button.classList.toggle('is-unavailable', !isAvailable);

      if (!isAvailable && button.classList.contains('is-active')) {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      }
    });

    if (!group.querySelector('.variant-option-button.is-active:not([hidden])')) {
      const firstAvailableButton = group.querySelector('.variant-option-button:not([hidden])');
      if (firstAvailableButton) {
        setActiveVariantButton(group, firstAvailableButton);
      }
    }
  });
};

const syncVariantForm = (picker) => {
  const form = picker.closest('form');
  if (!form) return;

  const variants = getVariantData(picker);
  const selectedOptions = getSelectedOptions(picker);
  const selectedVariant = variants.find((variant) => variant.available && variantMatchesOptions(variant, selectedOptions));

  if (!selectedVariant) return;

  const variantInput = form.querySelector('input[name="id"]');
  const addButton = form.querySelector('.product-card__add');
  const productAddButton = form.querySelector('.product__add');

  if (variantInput) {
    variantInput.value = String(selectedVariant.id);
  }

  if (addButton) {
    addButton.disabled = false;
    addButton.textContent = 'Add to cart';
  }

  if (productAddButton) {
    productAddButton.disabled = false;
    productAddButton.textContent = 'Add to cart';
  }

  syncVariantMedia(picker, selectedVariant);
};

const selectVariantOption = (button) => {
  if (!button || button.hidden || button.disabled) return;

  const picker = button.closest('[data-variant-picker]');
  const group = button.closest('[data-option-index]');
  if (!picker || !group) return;

  setActiveVariantButton(group, button);
  updateVariantOptionVisibility(picker);
  syncVariantForm(picker);
  syncSelectedVariantLabels(picker);
};

const bindVariantOptionButtons = (picker) => {
  picker.querySelectorAll('.variant-option-button').forEach((button) => {
    if (button.dataset.variantOptionReady === 'true') return;

    button.dataset.variantOptionReady = 'true';

    button.addEventListener('pointerdown', (event) => {
      if (button.hidden || button.disabled) return;

      event.preventDefault();
      event.stopPropagation();
      selectVariantOption(button);
    });

    button.addEventListener('click', (event) => {
      if (button.hidden || button.disabled) return;

      event.preventDefault();
      event.stopPropagation();
      selectVariantOption(button);
    });

    button.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (button.hidden || button.disabled) return;

      event.preventDefault();
      event.stopPropagation();
      selectVariantOption(button);
    });
  });
};

const initVariantPickers = (root = document) => {
  root.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    bindVariantOptionButtons(picker);
    updateVariantOptionVisibility(picker);
    syncVariantForm(picker);
    syncSelectedVariantLabels(picker);
  });
};

document.addEventListener('click', (event) => {
  const button = event.target.closest('.variant-option-button');
  if (!button || button.hidden || button.disabled) return;
  selectVariantOption(button);
});

initVariantPickers();

document.addEventListener('shopify:section:load', (event) => {
  initVariantPickers(event.target);
});

const applyCollectionProductSearch = (section) => {
  const input = section.querySelector('[data-collection-search-input]');
  const grid = section.querySelector('[data-product-grid]');
  const emptyMessage = section.querySelector('[data-collection-search-empty]');
  if (!input || !grid) return;

  const query = input.value.trim().toLowerCase();
  let visibleCount = 0;

  grid.querySelectorAll('[data-product-card]').forEach((card) => {
    const searchText = card.dataset.productSearchText || '';
    const isVisible = !query || searchText.includes(query);
    card.hidden = !isVisible;
    if (isVisible) {
      visibleCount += 1;
    }
  });

  if (emptyMessage) {
    emptyMessage.hidden = visibleCount !== 0;
  }
};

const initCollectionProductSearch = (root = document) => {
  root.querySelectorAll('.collection-page').forEach((section) => {
    const input = section.querySelector('[data-collection-search-input]');
    if (!input || input.dataset.collectionSearchReady === 'true') return;

    input.dataset.collectionSearchReady = 'true';
    input.addEventListener('input', () => applyCollectionProductSearch(section));
    applyCollectionProductSearch(section);
  });
};

initCollectionProductSearch();

const setInfiniteScrollStatus = (section, state) => {
  const status = section.querySelector('[data-infinite-scroll-status]');
  if (!status) return;

  const loading = status.querySelector('[data-infinite-scroll-loading]');
  const complete = status.querySelector('[data-infinite-scroll-complete]');

  status.hidden = state === 'idle';
  if (loading) loading.hidden = state !== 'loading';
  if (complete) complete.hidden = state !== 'complete';
};

const loadNextCollectionPage = async (section, observer) => {
  if (section.dataset.infiniteScrollLoading === 'true') return;

  const grid = section.querySelector('[data-product-grid]');
  const nextLink = section.querySelector('[data-next-page-link]');
  if (!grid || !nextLink) {
    setInfiniteScrollStatus(section, 'complete');
    if (observer) observer.disconnect();
    return;
  }

  section.dataset.infiniteScrollLoading = 'true';
  setInfiniteScrollStatus(section, 'loading');

  try {
    const response = await fetch(nextLink.href, {
      headers: { Accept: 'text/html' },
    });

    if (!response.ok) {
      throw new Error('Unable to load more products.');
    }

    const text = await response.text();
    const nextDocument = new DOMParser().parseFromString(text, 'text/html');
    const nextGrid = nextDocument.querySelector('[data-product-grid]');
    const nextPageLink = nextDocument.querySelector('[data-pagination] [data-next-page-link]');

    if (!nextGrid) {
      throw new Error('Next product grid was not found.');
    }

    Array.from(nextGrid.children).forEach((item) => {
      grid.appendChild(item);
    });

    initVariantPickers(grid);
    applyCollectionProductSearch(section);

    if (nextPageLink) {
      nextLink.href = nextPageLink.href;
      setInfiniteScrollStatus(section, 'idle');
    } else {
      nextLink.remove();
      setInfiniteScrollStatus(section, 'complete');
      if (observer) observer.disconnect();
    }
  } catch {
    section.classList.add('collection-page--infinite-error');
    setInfiniteScrollStatus(section, 'idle');
    if (observer) observer.disconnect();
  } finally {
    section.dataset.infiniteScrollLoading = 'false';
  }
};

const initInfiniteScroll = () => {
  document.querySelectorAll('[data-infinite-scroll]').forEach((section) => {
    if (section.dataset.infiniteScrollReady === 'true') return;

    const trigger = section.querySelector('[data-infinite-scroll-trigger]');
    if (!trigger) return;

    section.dataset.infiniteScrollReady = 'true';

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadNextCollectionPage(section, observer);
          }
        });
      }, {
        rootMargin: '700px 0px',
      });

      observer.observe(trigger);
      return;
    }

    const loadIfNearViewport = () => {
      const rect = trigger.getBoundingClientRect();
      if (rect.top <= window.innerHeight + 700) {
        loadNextCollectionPage(section);
      }
    };

    window.addEventListener('scroll', loadIfNearViewport, { passive: true });
    window.addEventListener('resize', loadIfNearViewport);
    loadIfNearViewport();
  });
};

initInfiniteScroll();

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-share-url]');
  if (!button) return;

  const url = button.dataset.shareUrl || window.location.href;
  const title = document.title;

  if (navigator.share) {
    await navigator.share({ title, url });
    return;
  }

  if (navigator.clipboard) {
    await navigator.clipboard.writeText(url);
    button.textContent = 'Link copied';
    window.setTimeout(() => {
      button.textContent = 'Share';
    }, 1800);
  }
});

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    const url = this.dataset.url;
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          initVariantPickers(this);
        }
      })
      .catch(() => {});
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}

// Open desktop dropdown menus on hover.
const initHoverMenus = () => {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.querySelectorAll('.site-header__nav-item--has-dropdown').forEach((item) => {
    const details = item.querySelector('.site-header__details');
    if (!details) return;

    let closeTimer;

    const openMenu = () => {
      if (!canHover.matches) return;

      clearTimeout(closeTimer);

      document.querySelectorAll('.site-header__details[open]').forEach((openDetails) => {
        if (openDetails !== details) {
          openDetails.open = false;
        }
      });

      details.open = true;
    };

    const closeMenu = () => {
      if (!canHover.matches) return;

      clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if (!item.matches(':hover') && !item.contains(document.activeElement)) {
          details.open = false;
        }
      }, 140);
    };

    item.addEventListener('mouseenter', openMenu);
    item.addEventListener('mouseleave', closeMenu);
    item.addEventListener('focusin', openMenu);
    item.addEventListener('focusout', closeMenu);
  });
};

initHoverMenus();

const initAnnouncementRotator = () => {
  document.querySelectorAll('[data-announcement-rotator]').forEach((rotator) => {
    const items = Array.from(rotator.querySelectorAll('.announcement-rotator__item'));
    if (items.length < 2) return;

    let activeIndex = items.findIndex((item) => item.classList.contains('is-active'));
    if (activeIndex < 0) activeIndex = 0;

    window.setInterval(() => {
      items[activeIndex].classList.remove('is-active');
      activeIndex = (activeIndex + 1) % items.length;
      items[activeIndex].classList.add('is-active');
    }, 7000);
  });
};

initAnnouncementRotator();
